import React from 'react';
import { useTranslation } from 'react-i18next';
import { NoSymbolIcon } from '@heroicons/react/24/outline';
import { signOut } from '../../firebase/auth';
import LanguageChip from '../../components/shared/LanguageChip';

export default function Suspended() {
  const { t } = useTranslation();
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)', padding: 24,
    }}>
      <div style={{
        maxWidth: 440, width: '100%', textAlign: 'center',
        background: 'var(--surface)', border: '1px solid var(--border)',
        borderRadius: 14, padding: '40px 32px',
      }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
          <LanguageChip />
        </div>
        <div style={{
          width: 56, height: 56, borderRadius: 14,
          background: '#fee2e2', display: 'flex', alignItems: 'center',
          justifyContent: 'center', margin: '0 auto 20px',
        }}>
          <NoSymbolIcon style={{ width: 28, height: 28, color: '#b91c1c' }} />
        </div>
        <h1 style={{ fontSize: 20, fontWeight: 700, color: 'var(--text-1)', letterSpacing: '-0.02em', marginBottom: 10 }}>
          {t('auth:suspended.title', 'Access suspended')}
        </h1>
        <p style={{ fontSize: 13.5, color: 'var(--text-3)', lineHeight: 1.6, marginBottom: 24 }}>
          {t('auth:suspended.description', "Your academy's access to the portal has been suspended. Please contact International Academy Portal support to resolve this.")}
        </p>
        <a
          href="mailto:info@internationalacademyportal.com"
          style={{
            display: 'inline-block', padding: '9px 20px',
            borderRadius: 8, background: 'var(--accent)', color: '#fff',
            fontSize: 13, fontWeight: 600, textDecoration: 'none', marginBottom: 12,
          }}
        >
          {t('auth:suspended.contactSupport', 'Contact support')}
        </a>
        <div>
          <button
            type="button"
            onClick={() => signOut()}
            style={{ fontSize: 12.5, color: 'var(--text-3)', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}
          >
            {t('common:actions.signOut')}
          </button>
        </div>
      </div>
    </div>
  );
}
